export default __webpack_public_path__ + "static/media/help-rav-qa-5.76a6e49f.png";